import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    if (isStandalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => setVisible(false);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) { console.debug('PWA install prompt dismissed:', e?.message || e); }
    setDeferred(null);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <button
      data-testid="install-pwa-btn"
      onClick={install}
      title="Install CurbAlert"
      className="glass-panel rounded-full px-3 py-2 flex items-center gap-2 hover:-translate-y-0.5 transition text-sm font-medium text-brand-ink"
    >
      <Download className="w-4 h-4 text-brand" />
      <span className="hidden sm:inline">Install</span>
    </button>
  );
};

export default InstallPWA;
